export const LANDING_PAGE_CMS_DATA = "/apim-admin";
export const GRAPHQL_PROXY = "api/graphql-proxy";
export const USER_BASE_URL = "https://app-apim-cms-prod-e4gjctfhhuh4dcdy.australiasoutheast-01.azurewebsites.net/";
